import MagnifyingGlassIcon from '@heroicons/react/24/outline/MagnifyingGlassIcon';
import { Button, Card, IconButton, InputAdornment, OutlinedInput, SvgIcon, Tooltip } from '@mui/material';
import ArrowDownTrayIcon from '@heroicons/react/24/outline/ArrowDownTrayIcon';
import CalendarIcon from '@heroicons/react/24/outline/CalendarIcon';
import { CustomPopOver } from './custom-popover';
import { usePopover } from '../hooks/use-popover';
import { useIsMobile } from '../hooks/use-is-mobile';
import { MobileSearchBar } from './mobile/mobile-search-bar';

export const CustomSearch = (props) => {
  const {
    popoverItems,
    handleSearch,
    exportExcel,
    getDataForExportExcel,
    selectedItems,
    confirmSelectedOrderStatus,
    statusOfOrder,
    from,
    to,
    handleBodyChange,
  } = props;
  const popOver = usePopover();
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileSearchBar {...props} />;
  }

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: 2.5,
        bgcolor: 'background.paper',
      }}
    >
      <CustomPopOver
        id={popOver.id}
        anchorEl={popOver.anchorRef}
        open={popOver.open}
        onClose={popOver.handleClose}
        popoverItems={popoverItems}
        from={from}
        to={to}
        handleBodyChange={handleBodyChange}
      />
      <OutlinedInput
        defaultValue=""
        fullWidth
        placeholder="Search"
        startAdornment={(
          <InputAdornment position="start">
            <SvgIcon
              color="action"
              fontSize="small"
            >
              <MagnifyingGlassIcon />
            </SvgIcon>
          </InputAdornment>
        )}
        sx={{ maxWidth: 500, mr: "auto" }}
        onChange={(event) => handleSearch && handleSearch(event)}
      />
      {confirmSelectedOrderStatus && statusOfOrder.map((item, index) => {
        return (
          <Button
            key={index}
            disabled={selectedItems.selected.length === 0}
            onClick={(event) => {
              confirmSelectedOrderStatus(item.value)
            }}
            variant="contained"
            sx={{
              color: "neutral.100",
              m: 1
            }}
          >
            {item.label}
          </Button>
        );
      })
      }
      {popoverItems &&
        <>
          <Tooltip title={'Download excel'}>
            <IconButton
              disabled={exportExcel}
              onClick={() => {
                getDataForExportExcel && getDataForExportExcel()
              }}
            >
              <SvgIcon fontSize="medium" sx={{ color: "text.primary", mx: 0.5 }}>
                <ArrowDownTrayIcon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title={'Filter by date'}>
            <IconButton
              onClick={(event) => {
                popOver.handleOpen(event)
              }}
            >
              <SvgIcon fontSize="medium" sx={{ color: "text.secondary" }}>
                <CalendarIcon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        </>
      }
    </Card>
  );
}
